import { Component, Vue } from 'vue-property-decorator';
import { isEmpty } from 'lodash';
import { HIVE_HOME_URL, PAGE_NAMES, SSO_CLIENT_ID , SSO_URL} from '@/constants';
import { login, exchangeToken } from '@/services';
import PageLoader from '@/components/common/loader/page-loader/PageLoader.vue';

@Component({
  components: {
    PageLoader
  }
})
export default class Login extends Vue {
  async mounted(): Promise<void> {
    const authCode: string = (this.$route.query.code || '') as string;
    if (authCode === null || authCode === '') {
      const returnURL = encodeURIComponent(HIVE_HOME_URL + "/login");
      window.location.href = `${SSO_URL}/oauth2/v2.0/authorize?response_type=code&&client_id=${SSO_CLIENT_ID}&scope=openid%20profile%20email&redirect_uri=${returnURL}`;
    } else {
        const token = await exchangeToken(authCode);
        if (token == "") {
            window.location.href = HIVE_HOME_URL + '/403.html';
        }
        const isAuthenticated = await login(token);
        if (isAuthenticated) {
          if (isEmpty(this.$store.getters['app/currentUser'])) {
            await this.$store.dispatch('app/fetchCurrentUser');
          }
          this.$router.replace({ name: PAGE_NAMES.HOME });
        } else {
          window.location.href = HIVE_HOME_URL + '/403.html';
        }
    }
  }
}
